<!-- 커스텀 시도 추가/수정 -->
<template>
  <div>
    <admin-box-item title="커스텀 시도 추가/수정" :useTab="false">

      <div class="columns is-multiline">
        <div class="column is-full">
          <admin-form-item label="커스텀 시도명(이름)*">
            <input class="input"
                   :value="value.custom_sido.name"
                   @input="e => value.custom_sido.name = e.target.value">
          </admin-form-item>
        </div>

        <div class="column is-full">
          <admin-form-item label="시도 드롭박스*">
            <span class="select">
              <select @change="setSidoData">
                <option value="" disabled selected>시/도</option>
                <option v-for="sido in value.sido_list" :value="sido.value">{{ sido.label }}</option>
              </select>
            </span>
          </admin-form-item>
        </div>

        <div class="column is-full">
          <admin-form-item label="선택된 시도">
            <div class="tags">
              <span class="tag is-primary is-medium"
                    v-for="sido, index in value.selected_sido">
                {{ sido }}
                <i class="material-icons" @click="delTag(index)">close</i>
              </span>
            </div>
          </admin-form-item>
        </div>
      </div>

      <div class="btn-group-justify-end">
        <button class="button is-light" @click="cancelModal">취소</button>
        <button class="button is-primary" @click="saveCustomSido">저장하기</button>
      </div>
    </admin-box-item>
  </div>
</template>

<script>

  export default {
    props:['data'],
    data () {
      return {
        value: {
          // 실제 데이터 백엔드에 보낼때
          custom_sido: {
            name:'',
            sido_set:[]
          },
          // 시도 리스트
          sido_list: [],
          // 선택된 시도 tag들
          selected_sido: []
        }
      }
    },
    created(){
      this.value = this.data;
    },
    watch:{
      data(n){
        if(n){
          this.value = n;
        }
      }
    },
    methods: {
      cancelModal(){
        this.$store.commit('cancelModal');
      },
      delTag(index){
        this.value.custom_sido.sido_set.splice(index, 1);
        this.value.selected_sido.splice(index, 1);
      },
      // 드롭박스 선택후 시도 저장
      setSidoData(e){
        let label = '';
        for(let i=0; i<this.value.sido_list.length; i++){
          if(this.value.sido_list[i].value==e.target.value){
            label = this.value.sido_list[i].label;
          }
        }
        this.value.selected_sido.push(label);
        this.value.custom_sido.sido_set.push(e.target.value);
      },
      //커스텀 시도 등록
      saveCustomSido(){
        let err = '';
        if(!this.value.custom_sido.name) err = '시도 이름을';
        else if(this.value.custom_sido.sido_set.length===0){
          err = '시도 드롭박스를'
        }

        if(err){
          this.toast(err+' 입력(선택) 하세요.');
          return;
        }
        // 수정
        if(this.value.custom_sido.id){
          this.$axios.patch('admin/address/featured/sido/'+this.value.custom_sido.id, this.value.custom_sido).then(res=>{
            if(res.status===200){
              this.toast('커스텀 시도가 등록되었습니다.');
              this.value = {
                custom_sido: {
                  name:'',
                    sido_set:[]
                },
                sido_list: [],
                  selected_sido: []
              };
              this.$store.commit('closeModal');
            }
          })
        }
        // 등록
        else{
          this.$axios.post('admin/address/featured/sido', this.value.custom_sido).then(res=>{
            if(res.status===200){
              this.toast('커스텀 시도가 등록되었습니다.');
              this.value = {
                custom_sido: {
                  name:'',
                  sido_set:[]
                },
                sido_list: [],
                selected_sido: []
              };
              this.$store.commit('closeModal');
            }
          })
        }
      },
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>
  #header
    #body
    #bottom
      padding 24px

</style>
